import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const ShieldSwooshIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc>shield</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M107.6 101a97.7 97.7 0 0 0 25.8-21V62.6a127.8 127.8 0 0 0-35.7-4.9A127.7 127.7 0 0 0 62 62.6v41.6a28.6 28.6 0 0 0 1.6 9.4c11.2 1.2 27.7-3.2 44-12.6Zm-35.1 29.9a92 92 0 0 0 25.2 18.9s35.7-17.3 35.7-42.8v-6.3a114.5 114.5 0 0 1-22 16.5 100 100 0 0 1-39 13.8Z"
        className="accent"
      />
      <path
        d="M147.3 61.5c-4.1-7.2-15.2-9.2-29-6.7 10.8-1.5 19.3.5 22.7 6.2 6.3 10.9-8.5 31.2-33.1 45.5s-49.8 17-56.1 6c-3.6-6-.5-15 7.1-24.2-10.2 11.3-14.5 22.7-10.1 30.2 7.2 12.3 35 9.5 62.3-6.3s43.4-38.5 36.2-50.8Z"
        className="accent"
      />
    </Icon>
  );
};

export default ShieldSwooshIcon;
